module.exports = __webpack_public_path__ + "img/qrcode_qq.c07f8d86.png";